import Axios from "axios";

const GET_DEPARTAMENTOS = "/Admin/getDepartamento/";
const SET_DEPARTAMENTOS = "/Admin/AddDepartamento/";
const GET_MENUS = "/Admin/getMenu/";
const SET_MENUS = "/Admin/AddMenu/";
const GET_SUBMENUS = "/Admin/getSubMenu/";
const SET_SUBMENUS = "/Admin/AddSubMenu/";
const SET_MENUS_DEPARTAMENTO = "/Admin/AddDepartamentoMenu/";

export default {
  departamentos: {
    getAll(id = 0) {
      return Axios.get(GET_DEPARTAMENTOS + id);
    },
    set(payload) {
      return Axios.post(SET_DEPARTAMENTOS, payload);
    },
    setMenu(payload) {
      return Axios.post(SET_MENUS_DEPARTAMENTO, payload);
    }
  },
  menus: {
    getAll(id = 0) {
      return Axios.get(GET_MENUS + id);
    },
    set(payload) {
      return Axios.post(SET_MENUS, payload);
    }
  },
  submenus: {
    getAll(id = 0) {
      return Axios.get(GET_SUBMENUS + id);
    },
    set(payload) {
      return Axios.post(SET_SUBMENUS, payload);
    }
  }
};
